const riot = require('riot');
riot.tag2('report_segment', 'name <div class="property"> <span>{AND/NOT}</span> <span>{property}</span> <span>{measures}</span> <i class="fas fa-times"></i> </div> <div class="interest"> <span>{must/should/not}</span> <span>{interest}</span> <span>{frequency}</span> <i class="fas fa-times"></i> </div>', '', '', function(opts) {
});

riot.tag2('tbl', '<table style="width:auto"> <thead> <tr> <th each="{head in opts.tbl_data[0]}">{head}</th> </tr> </thead> <tbody> <tr each="{row in opts.tbl_data.slice(1)}"> <td each="{val in row}"><raw html="{val}"></raw></td> </tr> </tbody> </table>', '', '', function(opts) {

  console.log('TBL',opts)
});



import echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/map'
import 'echarts/lib/component/geo'
import 'echarts/lib/component/visualMap'
import 'echarts/lib/component/tooltip'
import geojson from '../../assets/Statisticne_regije.json'
import './raw.tag'
riot.tag2('graph', '<h5>{opts.title}</h5> <div ref="chart" riot-style="min-height:{opts.height || 400}px"> </div>', '', '', function(opts) {

  const self = this

  if (opts.name=='regions') echarts.registerMap('slovenia', geojson);

  self.on('mount',function() {
    let chart = echarts.getInstanceByDom(self.refs.chart)

    if (!chart) chart = echarts.init(self.refs.chart,'light')

console.log('GRPH',chart,self.refs.chart,opts)

    chart.setOption(opts.graph_data)
  })

});



import iab_parse from '../../assets/iab_parser.js'
import './raw.tag'
import marked from 'marked'
riot.tag2('report', '<div class="card is-collapse"> <header class="card-header {has-background-light:expanded}"> <p class="card-header-title" onclick="{toggleExpanded}"> {name} </p> <a href="#" class="card-header-icon" onclick="{toggleExpanded}" aria-label="more options"> <span class="icon"> <i class="fas fa-angle-down" aria-hidden="true"></i> </span> </a> </header> <div if="{expanded}" class="card-content has-background-white-bis" style="margin-bottom:1rem"> <form onsubmit="{returnFalse}"> <div class="columns"> <div class="column"> <div class="field control"> <label for="name" class="label">Name</label> <input class="input" type="text" riot-value="{name}" id="name" ref="name"> </div> <div class="field"> <div class="control"> <label for="id" class="label">Customer</label> <div class="control"> <div class="select is-small"> <select name="new_customer" ref="new_customer" onchange="{setCustomer}"> <option>Select customer</option> <option each="{customers}" selected="{_id==parent.customer_id}" riot-value="{_id}">{name}</option> </select> </div> </div> </div> </div> </div> <div class="column"> <div class="field is-grouped"> <div class="control"> <label for="dtstart" class="label">Start Date</label> <input class="input" riot-value="{dtstart}" onchange="{setDates}" ref="dtstart" type="{\'date\'}"> </div> <div class="control"> <label for="dtend" class="label">End Date</label> <input class="input" riot-value="{dtend}" onchange="{setDates}" ref="dtend" type="{\'date\'}"> </div> </div> <div class="field"> <div class="control"> <label for="sites">Site(s)</label> <textarea class="input" onchange="{setSites}" ref="sites">{sites.join(\'\\n\')}</textarea> </div> </div> </div> </div> <div class="columns"> <div class="column"> <label class="label">Detailed segments</label> </div> <div class="column"> <label class="label">Other segments</label> </div> </div> <div class="columns"> <div class="column"> <label class="label">Template</label> <textarea class="input" ref="template" onchange="{setTemplate}">{template}</textarea> </div> </div> <div class="columns"> <div class="column"> <div class="field is-grouped"> <div class="control"> <label class="label">Document</label> </div> <div class="control"> <button class="button is-small {is-info:data_dirty}" onclick="{render}">Refresh</button> </div> </div> <div class="content" ref="rendered"> <raw html="{rendered}"></raw> </div> </div> </div> <div class="field is-grouped is-grouped-centered"> <div class="control"> <button class="button is-info" onclick="{saveReport}">Save changes</button> </div><div class="control"> <button class="button is-light" onclick="{removeReport}">Remove report</button> </div> </div> </form> </div> </div>', '', '', function(opts) {

  Date.prototype.toISODate = function() {
    return this.toISOString().replace(/T.*$/,'')
  }

  const
    self = this,
    now = new Date(),
    day = now.getDate(),
    month = now.getMonth(),
    year = now.getFullYear(),
    today = new Date(year,month,day,12),
    ago = (days, date) => new Date(new Date(date || today).valueOf() - days*24*3600*1000).toISODate()

  this.toggleExpanded = function(e) {
    e.preventDefault()
    e.stopPropagation()
    self.expanded = !self.expanded
console.log('report dates',self.dtstart,self.dtend)

  }.bind(this)

  self.customers = self.parent.customers;
  self.customer = self.customers.find(c => c._id==self.customer_id)

  self.detailed_segments = self.detailed_segments || []
  self.other_segments = self.other_segments || []
  self.dtstart = self.dtstart || ago(30)
  self.dtend = self.dtend || today.toISODate()
  self.sites = self.sites || []

	self.data_dirty = !self.data

  this.setCustomer = function(e) {
    e.preventDefault()
    self.customer_id = self.refs.new_customer.value
    self.customer = self.customers.find(c => c._id==self.customer_id)
console.log('hav customer',self.customer)
    self.sites = [...self.customer.sites]
    self.data_dirty = true
  }.bind(this)

  this.setDates = function(e) {
    e.preventDefault()
    self.dtstart = self.refs.dtstart.value
    self.dtend = self.refs.dtend.value
console.log('new dates?',self.dtstart,self.dtend)
    self.data_dirty = true
  }.bind(this)

  this.setSites = function(e) {
    e.preventDefault()
    self.sites = self.refs.sites.value.split(/[,\s\n]/g)
console.log('new sites?',self.sites)
    self.data_dirty = true
  }.bind(this)

  this.setTemplate = function(e) {
    e.preventDefault()
    self.template = self.refs.template.value
console.log('new template?',self.template)
  }.bind(this)

	function renderReport() {
    const renderer = new marked.Renderer();

    renderer.heading = (text, level) => {
      const cls = level==1 ? 'subtitle' : 'title'
      return `
              <h${level} class="${cls} is-${level}">
                ${text}
              </h${level}>`;
    };
    let rendered = marked(self.template,{renderer})
                      .replace(/\{table_(.*?)\}/g,'<tbl name="$1" tbl_data={tbl_data_$1}></tbl>')
                      .replace(/\{graph_(.*?)(\|(.*?))?(\|(.*?))?\}/g,'<graph name="$1" graph_data={graph_$1} height="$3" title="$5"></graph>')
                      .replace(/\{/g,'{opts.')
                      .replace(/\|(.*?)\}/g,'("$1")}')
    console.log('renered',rendered)
    riot.tag('render',rendered)

    const nice_date = (d) => (new Date(d)).toLocaleDateString('sl-SI'),
    			iso_date = (d) => (new Date(d)).toISODate(),
    			percent = (d) => (100 * d).toFixed(2),
    			measures = api.get('measures')

    const
      res = self.data,
      pv_total = res.aggregations.pages.date_filtered.pageviews.value,
      pv_profiled = res.aggregations.profiled.pages.date_filtered.pageviews.value,
      daymax = res.aggregations.pages.date_filtered.datum.buckets.reduce( (a,c) => {
        if (c.pageviews.value>a.pageviews.value) return c
        return a
      },{pageviews:{value:0}}),
      daymax_profiled = res.aggregations.profiled.pages.date_filtered.datum.buckets.find( b => {
        return b.key_as_string==daymax.key_as_string
      }),
      table_daymax = [
      	[daymax.date,'Obiskovalci','Ogledi'],
      	['Vsi',daymax.profiles.doc_count,daymax.pageviews.value],
      	['Profilirani',daymax_profiled.profiles.doc_count,daymax_profiled.pageviews.value]
      ],
      visitors_profiled = res.aggregations.profiled.doc_count,
      visitors_total = res.hits.total,
      views = res.aggregations.pages.date_filtered.datum.buckets,
      views_profiled = res.aggregations.profiled.pages.date_filtered.datum.buckets,
      pages = res.aggregations.profiled.pages.date_filtered.top_page.buckets,
      top_page = pages[0].url,
      table_pages = [['Stran','Obiskovalci','Ogledi'], ...pages.map(p => [p.url,p.profiles.doc_count,p.pageviews.value])],
      genderage = {
        male: res.aggregations.gender.buckets.find(b => b.key=='male'),
        female: res.aggregations.gender.buckets.find(b => b.key=='female')
      },
      genderage_percent = (sel,gender) => {
        if (!sel) return (100 * genderage[gender].doc_count / visitors_profiled).toFixed(2)
        return (100 * genderage[gender].age.buckets.reduce( (sum,b) => {
          if ( sel.indexOf(b.key)<0 ) return sum
          return sum + b.doc_count
        },0) / genderage[gender].doc_count).toFixed(2)
      },
      age = res.aggregations.age,
			age_percent = (sel) => {
        if (!sel) return (100).toFixed(2)
        return (100 * age.buckets.reduce( (sum,b) => {
          if ( sel.indexOf(b.key)<0 ) return sum
          return sum + b.doc_count
        },0) / visitors_profiled).toFixed(2)
      },
      browsers = res.aggregations.browser.buckets.reduce( (a,c) => {
				var cd = c.key.match(/(Safari|Firefox|Chrome|Opera|IE|Edge)/i),
						cc = cd && cd[1]  || c.key
				a[cc] = a[cc] || 0
				a[cc] += c.doc_count
				return a
			},{}),
			browser_keys = Object.keys(browsers).sort( (a,b) => {
					var aa = browsers[a], bb = browsers[b]
					if (aa>bb) return -1
					if (aa>bb) return 1
					return 0
			}),
      browser_percent = (idx) => {
        const key = browser_keys[idx-1], count = browsers[key]
        return key + ' (' + percent(count / visitors_total ) + '%)'
      },
      table_browsers = [ ['Brskalnik','Obiskovalci (%)'], ...browser_keys.map(k => [k,percent(browsers[k]/visitors_total)]) ],
      regions = {},
      region_list = [],
      countries = {},
      region_percent = (idx) => {
        if (!idx) return (100 * regions_total / countries['Slovenia']).toFixed(2)
        const r = region_list[idx-1]
        return r.name + ' (' + (100 * r.value / regions_total).toFixed(2) + '%)'
      },
      tags = res.aggregations.bex.filtered.tags.buckets,
      topkeys = Object.keys(tags).sort((a,b) => {
                  const aa=tags[a].doc_count, bb=tags[b].doc_count
                  if (aa<bb) return 1
                  if (aa>bb) return -1
                  return 0
                }),
      toptags = topkeys.map( k => ({tag:measures[k].name, count:tags[k].doc_count}) ),
      stags = res.aggregations.bex.filtered.toptags.buckets,
      data_stags = stags.slice(0,100).reduce( (a,t) => {
      	var tkey = t.key.split('|')[0],
      			tag = a.data
      	tag[tkey] = tag[tkey] || []
      	tag[tkey].push([measures[t.key] && measures[t.key].name || 'error: '+t.key, t.key, ++a.count])
      	return a
      },{data:{},count:0}),
      table_tags = [
         ['Interes','Oznaka','Rang'],
         ...Object.keys(data_stags.data).reduce( (a,k) => {
          var t = data_stags.data[k]
          a.push(['<b>'+measures[k].name+'</b>','',''])
          return a.concat(t)
         },[] )
      ],
      top10_total = res.aggregations.profiled.bex.filtered.profiles.doc_count,
      top10_list = toptags.slice(0,10).map(b => {
        return b.tag+' ('+percent(b.count/top10_total)+'%)'
      })

console.log('top10_total',top10_total,visitors_total,table_browsers)

		  let regions_total = 0
		  res.aggregations.pages.date_filtered.regions.buckets.forEach(b => {
		  	const p = b.key.split(/\|/g)
		  	let idx = p[0]
		  	countries[idx] = +(countries[idx] || 0) + b.profiles.doc_count
		  	if (idx=='Slovenia' && p[1]) {
		  	  idx = p[1]
		      if (idx=='Jugovzhodna Slovenija') idx = 'Dolenjska'
		    	regions[idx] = +(regions[idx] || 0) + b.profiles.doc_count
		    	regions_total += b.profiles.doc_count
		    }
		  })
		  let profiled_regions_total = 0
		  res.aggregations.profiled.pages.date_filtered.regions.buckets.forEach(b => {
		  	const p = b.key.split(/\|/g)
		  	if (p[0]=='Slovenia') {
		    	profiled_regions_total += b.profiles.doc_count
		    }
		  })
		  console.log('cross regions',profiled_regions_total,countries['Slovenia'])
		  const keys=Object.keys(regions)
		  keys.sort(function(a,b) {
		    var aa=+regions[a], bb=+regions[b]
		    if (aa<bb) return 1
		    if (aa>bb) return -1
		    return 0
		  })
		  for (let k of keys) region_list.push({name:k,value:regions[k]})
		  console.log('region list',region_list)
			daymax.date = nice_date(daymax.key_as_string)
		  const
		    table_regions = [['Regija','Obiskovalci (%)'],...region_list.map(r => [r.name,percent(r.value/regions_total)])],
		    region_max = region_list[0].value,
				graph_regions = {
					tooltip: {},
					visualMap: [{
						  type: 'continuous',
						  min: 0,
							max: region_max,
							left: 'left',
							top: 'center',
				      text: [region_max,'0'],
							seriesIndex: [0],
							inRange: {
								  color: ['#e0ffff','#006edd']
							}
					}],
					geo: [{
						map: 'slovenia',
						label: {
						    normal: {
						        show: true,
						        textStyle: {
						            color: 'rgba(0,0,0,0.4)'
						        }
						    }
						},
						itemStyle: {
						    normal:{
						        borderColor: 'rgba(0,0,0,0.2)'
						    },
						    emphasis:{
						        areaColor: null,
						        shadowOffsetX: 0,
						        shadowOffsetY: 0,
						        shadowBlur: 20,
						        borderWidth: 0,
						        shadowColor: 'rgba(0,0,0,0.5)'
						    }
						}
					}],
				  grid: [
					  {x: '0%', y:'0%', width: '100%',height:'100%'}
				  ],
					series: [{
						name:'Region',
						type:'map',
						geoIndex: 0,
						data: region_list
					}]
				},
				graph_daily = {
					xAxis: {
						type: 'time',
						axisLabel:{showMinLabel:false,showMaxLabel:false},
						axisPointer:{
							value: iso_date( new Date(daymax.key) ),
		          snap: true,
		          lineStyle: {
		              color: '#004E52',
		              opacity: 0.5,
		              width: 2
		          },
		          label: {
		              show: true,
		              formatter: function (params) {
		                  return echarts.format.formatTime('yyyy-MM-dd', params.value);
		              },
		              backgroundColor: '#004E52'
		          },
		          handle: {
		              show: true,
		              color: '#004E52'
		          }
						}
					},
					yAxis: [
						{type:'value',name:'Obiskovalci',nameLocation:'end',nameTextStyle:{fontWeight:'bold'}},
						{type:'value',name:'Ogledi',nameLocation:'end', nameTextStyle:{fontWeight:'bold'}}
					],
					tooltip: {
						  triggerOn: 'click'
					},
					legend: {
						data: ['All visitors', 'Selected visitors','All pageviews', 'Selected pageviews']
					},
					grid: [
						{x: '2%', y:'15%', width: '98%',height:'85%',containLabel:true}
					],
					series: [
						{ type: "line", name: "All visitors", areaStyle:{},
							data: views.map(k => [iso_date(k.key),k.profiles.doc_count] ) },
						{ type: "line", name: "Selected visitors", areaStyle:{},
							data: views_profiled.map(k => [iso_date(k.key),k.profiles.doc_count] ) },
						{ type: "line", yAxisIndex:1, name: "All pageviews",
							data: views.map(k => [iso_date(k.key),k.pageviews.value] ) },
						{ type: "line", yAxisIndex:1, name: "Selected pageviews",
							data: views_profiled.map(k => [iso_date(k.key),k.pageviews.value] ) },
					]
				},
				labels = [ '10-17','18-24','25-29','30-39','40-49','50-59','60+']
			let data_max = 0
			const
				data_female = genderage.female.age.buckets.map(b => {
					if (data_max<b.doc_count) data_max=b.doc_count
					return [b.key,b.doc_count]
				}),
				data_male = genderage.male.age.buckets.map(b => {
					if (data_max<b.doc_count) data_max=b.doc_count
					return [b.key,b.doc_count]
				}),
				graph_gender = {
					tooltip : {
						trigger: 'axis',
						axisPointer : {
							type : 'shadow'
						}
					},
					legend: {
						data: ['Ženske','Moški']
					},
					grid: [
						{x: '4%', y:'7%', width: '98%',height:'40%',containLabel:true},
						{x: '4%', y:'48%', width: '98%',height:'40%',containLabel:true},
					],
					xAxis: [
						{type:'category',gridIndex: 0, data:labels, name:'Starost',nameLocation:'start',nameTextStyle:{padding:[28,0,0,0],fontWeight:'bold'}},
						{type:'category',gridIndex: 1, data:labels, axisLabel:{show:false}},
					],
					yAxis: [
						{type:'log',min:1,gridIndex: 0, max:data_max, name:'Moški', axisLabel:{showMinLabel:false},nameTextStyle:{fontWeight:'bold'}},
						{type:'log',min:1,gridIndex: 1, max:data_max, inverse:true, name:'Ženske', axisLabel:{showMinLabel:false},nameTextStyle:{fontWeight:'bold'}},
					],
					series: [
						{
								name: 'Ženske',
								type: 'bar',
								label: {
										normal: {
										    show: true,
										    position: 'inside'
										}
								},
								barWidth:60,
								z:10,
								yAxisIndex:1,
								xAxisIndex:1,
								data: data_female
						},
						{
								name: 'Moški',
								type: 'bar',
								label: {
										normal: {
										    show: true,
										    position: 'inside'
										}
								},
								z:10,
								barWidth:60,
								yAxisIndex:0,
								xAxisIndex:0,
								data: data_male
						}
					]
				}

			const
				bextags = res.aggregations.bex.filtered.tags.buckets,
				bexlabels = Object.keys(bextags).sort( (a,b) => {
					const aa = bextags[a].doc_count, bb = bextags[b].doc_count
					return (aa>bb) ? -1 : (aa<bb) ? 1 : 0
				}),
				bexdata = bexlabels.map(k => bextags[k].doc_count || null),
				bexnames = bexlabels.map(k => measures[k].name),
				graph_bex_tier1 = {
					tooltip : {
						trigger: 'axis',
						axisPointer : {
							type : 'shadow'
						}
					},
					grid: [
						{x: '2%', y:'6%', width: '98%',height:'94%',containLabel:true}
					],
					yAxis: [
						{type:'category', data: bexnames, inverse:'true'},
					],
					xAxis: [
						{type:'log',axisLabel: {showMaxLabel:false}, position:'top'},
					],
					series: [
						{
								name: 'Visitors',
								type: 'bar',
								stack: '',
								label: {
									  normal: {
									      show: true,
									      position: 'insideBottom'
									  }
								},
								barWidth:"73%",
								barGap:"-110%",
								data: bexdata
						},
					]
				},
				devices = res.aggregations.device.buckets,
				device_labels = devices.map( d => d.key ),
				device_data = devices.map( (d,idx) => ({name:d.key,value:d.doc_count,selected:idx==0}) ),
				table_devices = [['Naprava','Obiskovalci (%)'],...devices.map(d => [d.key,percent(d.doc_count/visitors_total)]) ],
				graph_devices = {
						tooltip : {
								trigger: 'item',
								formatter: "{a} <br/>{b} : {c} ({d}%)"
						},
						label:{
								color:'black',
						},
						series : [
								{
								    name: 'devices',
								    type: 'pie',
								    radius : '75%',
								    center: ['50%', '50%'],
								    data: device_data,
								    itemStyle: {
								        emphasis: {
								            shadowBlur: 10,
								            shadowOffsetX: 0,
								            shadowColor: 'rgba(0, 0, 0, 0.5)'
								        }
								    }
								}
						]
				},
				browser_data = browser_keys.map( (k,idx) => ({name:k,value:browsers[k],selected:idx==0}) ),
				graph_browsers = {
						tooltip : {
								trigger: 'item',
								formatter: "{a} <br/>{b} : {c} ({d}%)"
						},
						label:{
								color:'black',
						},
						series : [
								{
								    name: 'browser',
								    type: 'pie',
								    radius : '75%',
								    center: ['50%', '50%'],
								    data: browser_data,
								    itemStyle: {
								        emphasis: {
								            shadowBlur: 10,
								            shadowOffsetX: 0,
								            shadowColor: 'rgba(0, 0, 0, 0.5)'
								        }
								    }
								}
						]
				}

			var tag = riot.mount(self.refs.rendered,'render',{
			  customer_name: self.customer.name,
			  customer_site: self.sites.join(', '),
			  dtend: nice_date(self.dtend),
			  dtstart: nice_date(self.dtstart),
			  visitors_total: visitors_total,
			  visitors_profiled: visitors_profiled,
			  pv_total: pv_total,
			  pv_profiled: pv_profiled,
			  pv_profiled_percent: percent(pv_profiled / pv_total),
			  daymax: daymax,
			  daymax_profiled: daymax_profiled,
			  top_page: top_page,
			  female_percent: (sel) => genderage_percent(sel,'female'),
			  male_percent: (sel) => genderage_percent(sel,'male'),
			  age_percent: age_percent,
			  top_device: {desktop:'desktopa',phone:'mobilnega telefona',tablet:'tabličnega računalnika'}[res.aggregations.device.buckets[0].key],
			  browser_percent: browser_percent,
			  tbl_data_browsers: table_browsers,
			  tbl_data_pages: table_pages,
			  tbl_data_bex100: table_tags,
			  tbl_data_regions: table_regions,
			  tbl_data_daymax: table_daymax,
			  tbl_data_devices: table_devices,
			  graph_regions:graph_regions,
			  graph_daily:graph_daily,
			  graph_gender:graph_gender,
			  graph_devices:graph_devices,
			  graph_browsers:graph_browsers,
			  graph_bex_tier1:graph_bex_tier1,
			  region_percent: region_percent,
			  region_cross_percent: percent(profiled_regions_total / visitors_profiled - 1),
			  bex_tag_count: res.aggregations.bex.filtered.toptags.buckets.length,
			  top10_total: percent(top10_total / visitors_profiled),
			  top10_list: top10_list.join(', ')
			})
			self.rendered = self.refs.rendered.innerHTML

	}

  this.render = function(e) {
    if (e) {
      e.preventDefault();
      self.data_dirty = 1;
    }

  	const
  	  dtend = ago(-1,self.dtend),
  	  nested_filter = {"bool": {"must": [
                        {"range":{"visited.date":{"gte":self.dtstart,"lte":dtend}}},
                        {"terms": {"visited.site":self.sites}}
                      ] } },
      profile_filter = 'valid:['+self.dtstart+' TO '+dtend+'] AND profile.sites:('+self.sites.join(' ')+')'

    if (self.data && !self.data_dirty) {
    console.log('self datas',self.data)
      preloader.inc()
    	renderReport()
      preloader.dec()
    } else {
			preloader.inc()
    	api.service('stats-report')
      .find({ query: {profile_filter, nested_filter, detailed_segments:self.detailed_segmenets, other_segmenets:self.other_segments} })
      .then(res => {
      	var pages = res.aggregations.profiled.pages.date_filtered.top_page.buckets,
      	    page_ids = pages.map(p => p.key)
console.log('fetching pages',page_ids)
      	return api.service('page')
      						.find({query:{page_id:{$in:page_ids}}})
      						.then(pgs => {
      							console.log('pages',pgs)
      							var urls = {}
      							pgs.data.forEach(p => urls[p.page_id] = p.page_proto+'://'+p.page_url)
      							pages.forEach(p => p.url = urls[p.key])
      							return res
      						})
      						.catch( (err) => {
      							console.log('err fetching pages',err)
						        api.emit('toast',{type:'danger',title:'Error fetching data',content:e.message})
						        return res
      						})

      })
      .then(res => {
        preloader.dec()
        console.log('datas',res)
        self.data = res
        self.data_dirty = false
        self.update()
        api.emit('toast',{type:'info',title:'Data fetch complete'})
        renderReport()
      })
      .catch(e => {
        console.log('err fetching data',e)
        api.emit('toast',{type:'danger',title:'Error fetching data',content:e.message})
      })
    }
  }.bind(this)

	self.on('updated',function() {
    if (self.expanded) self.render()
	})

  this.saveReport = function(e) {
    e.preventDefault()
    const
      customer = self.customer,
      report = {
        name:self.refs.name.value,
        owner:customer.owner,
        customer_id:customer._id.toString(),
        sites:self.sites,
        dtstart:self.dtstart,
        dtend:self.dtend,
        detail_segments:self.detail_segments,
        other_segments:self.other_segments,
        template:self.template,
        rendered:self.rendered,
        data:self.data
      }
console.log('report',report)
    api.service('reports')
    .patch(e.item._id,report)
    .then(r => {
console.log('saved report',r)
      const id = self.parent.reports.findIndex(d => d._id==e.item._id)
      report._id = e.item._id
      self.parent.reports[id] = report
      self.parent.update()
    })
    .catch(e => {
      console.log('error patching report',e)
      self.error = e.message
      self.update()
    })
    console.log('saving',e)

  }.bind(this)

  this.removeReport = function(e) {
    const id = e.item._id
    e.preventDefault()
    api.service('reports').remove(id)
    .then(res => {
      self.parent.reports = self.parent.reports.filter(c => c._id!=id)
      self.parent.update()
      api.emit('toast',{type:'info',title:'Report removed'})
    })
    .catch(e => api.emit('toast',{type:'danger',title:'Error deleting report',content:e.message}))
  }.bind(this)

});

